import { render, staticRenderFns } from "./LegacyRwImage.vue?vue&type=template&id=41b62a6a"
import script from "./LegacyRwImage.vue?vue&type=script&lang=js"
export * from "./LegacyRwImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports